<template>
    <div class="new-address-component">
        <div class="row">
            <div class="col-sm-6">
                <div :class="groupClassNames('company')">
                    <input class="form-control" name="address[company]" v-model="value.company" placeholder="Firma">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div :class="groupClassNames('name')">
                    <input class="form-control" name="address[name]" v-model="value.name" placeholder="Vor- und Nachname">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div :class="groupClassNames('street')">
                    <input class="form-control" name="address[street]" v-model="value.street" placeholder="Straße und Hausnummer">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8">
                <div :class="groupClassNames('city')">
                    <input class="form-control" name="address[city]" v-model="value.city" placeholder="Stadt">
                </div>
            </div>
            <div class="col-sm-4">
                <div :class="groupClassNames('zip')">
                    <input class="form-control" name="address[zip]" v-model="value.zip" placeholder="PLZ">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <div :class="groupClassNames('country')">
                    <select class="form-control" name="address[country]" v-model="value.country">
                        <option value="" disabled selected>Land</option>
                        <option v-for="country in countries" :key="country.id" :value="country.id" :selected="(country.id == value.country)">{{ country.name }}</option>
                    </select>
                </div>
            </div>
            <div v-if="saving" class="col-sm-6">
                <a class="btn btn-info" @click.prevent="save">
                    <i v-if="loading" class="fa fa-fw fa-spin fa-spinner"></i>
                    <i v-else class="fa fa-fw fa-check"></i>
                    Speichern
                    </a>
                <a class="btn btn-default" @click.prevent="close"><i class="fa fa-fw fa-times"></i> Cancel</a>
            </div>
        </div>
        <div v-if="error" class="row">
            <div class="col-sm-12">
                <div class="alert alert-danger">
                    <strong>Error!</strong>
                    {{ errorMessage }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  
    props: {
        countries: {
            type: [Array, Object],
            required: true
        },
        value: {
            type: [Object],
            default: () => {
                return {
                    company: '',
                    name: '',
                    street: '',
                    city: '',
                    zip: '',
                    country: ''
                }
            }
        },
        saving: {
            type: [Boolean],
            default: false
        }
    },

    data() {
        return {
            loading: false,
            error: false,
            errorMessage: '',
        }
    },

    methods: {

        validField(name) {
            return this.value[name].length > 0;
        },

        groupClassNames(name) {
            return {
                "form-group": true,
                "has-error":  ! this.validField(name)
            }
        },

        validate() {
            return (
                this.validField('company') &&
                this.validField('name') &&
                this.validField('street') &&
                this.validField('city') &&
                this.validField('zip') &&
                this.validField('country')
            );
        },

        close() {
            this.$emit('close');
        },

        save() {

            if (this.validate()) {
                this.error = false;
                this.loading = true;
                new Form(this.value).post('/api/addressbook/save')
                .then(result => {
                    this.loading = false;
                    if (result.success) {
                        App.event.fire('address-added', result.address);
                        this.$emit('save', result.address);
                    } else {
                        this.error = true;
                        this.errorMessage = result.error;
                    }
                });
            } else {
                this.error = true;
                this.errorMessage = 'Please fill in all required fields.';
            }
        }


    },

    watch: {

        value: {
            deep: true,
            handler: function() {
               this.$emit('input', this.value);   
            }
        }
    }

}
</script>
